//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      promoActive: 'promo/promoActive',
      promoText: 'promo/promoText',
      promoMode: 'promo/promoMode',
      promoDismissed: 'promo/promoDismissed',
      isUK: 'store/isUK',
      isEU: 'store/isEU',
      isROW: 'store/isROW'
    }),
    classes () {
      return {
        'page-promo-banners': true,
        uk: this.isUK,
        eu: this.isEU,
        row: this.isROW
      }
    },
    visible () {
      if (!this.promoActive) return false
      if (this.promoDismissed) return false
      if (this.promoMode === 'FREE_SHIPPING_AND_CAPSULE') return false
      if (this.$route.fullPath.includes('/checkout')) return false
      return true
    }
  }
}
